import * as React from "react"
import * as Money from "../../util/money"
import { RecipientSummary } from "./RecipientSummary"
import { RecipientState } from "../BulkCreditRecipientForm"

interface Props {
  recipientState: RecipientState
  recipientSummary: RecipientSummary
  tripHidingPendingPassengers: boolean
  children: React.ReactNode
}

const spinner = (
  <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
    <path
      fill="currentColor"
      d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
    >
      <animateTransform
        attributeType="xml"
        attributeName="transform"
        type="rotate"
        from="0 25 25"
        to="360 25 25"
        dur="0.6s"
        repeatCount="indefinite"
      />
    </path>
  </svg>
)

function RecipientStatusInfo({ status }) {
  if (status === "Pending") {
    return <div className="inline-block text-md text-red-600 px-2 ">{status}</div>
  }
  else {
    return <div className="inline-block text-sm text-gray-900 px-2 bg-gray-200 rounded-full">{status}</div>
  }
}

function recipientIsPending(recipientStatus) {
  const pendingFilters = ["pending_and_missing_info", "pending_and_no_deposit", "pending_and_partial_deposit"];

  return pendingFilters.includes(recipientStatus);
}

export function RecipientContainer(props: Props) {
  const { recipientState, recipientSummary } = props

  let status = recipientSummary.recipient_status
  return (
    <div
      className="items-center table-row bulk-credit-recipient-card sm:grid-cols-5"
      data-role={`participation[${props.recipientSummary.participation_id}]`}
    >
      <div className="font-bold sm:col-span-2" data-role="passenger-name">
        <span>{props.recipientSummary.recipient_name}</span>
        {status === null && <RecipientStatusInfo status={"Removed From Trip"} />}
        {status === "on_waitlist" && <RecipientStatusInfo status={"On Waitlist"} />}
        {status === "cancelled" && <RecipientStatusInfo status={"Cancelled"} />}
        {props.tripHidingPendingPassengers && recipientIsPending(status) && <RecipientStatusInfo status={"Pending"} />}
      </div>
      <div className="text-gray-700" data-role="passenger-package">
        <span>{props.recipientSummary.package_name}</span>
      </div>
      <div className="relative flex items-center sm:col-span-2">
        <span className="row text-sm spinner-highlight whitespace-nowrap sm:text-base">
          {props.children}

          {recipientState.isAutosaveInProgress ? (
            <span className="spinner">{spinner} Saving</span>
          ) : (
            <>
              {recipientState.error === undefined ? (
                <span className="ml-1">
                  credit to the balance of{" "}
                  <span className="font-semibold">{Money.formatCentsAsUsd(props.recipientSummary.account_balance)}</span>
                </span>
              ) : (
                <span className="ml-1 font-semibold text-red-700">{recipientState.error}</span>
              )}
            </>
          )}
        </span>
      </div>
    </div>
  )
}
